import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var GoBackward10 = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement(SvgFill, {
    d: "M23.297 21.273c-.698.997-1.097 2.494-1.097 4.09 0 1.597.499 3.093 1.097 4.09.698.999 1.496 1.498 2.294 1.498s1.696-.5 2.294-1.497c.698-.998 1.097-2.494 1.097-4.09 0-1.597-.498-3.094-1.097-4.091-.698-.998-1.496-1.497-2.294-1.497-.698 0-1.596.499-2.294 1.497Zm-1.496-.998c.898-1.297 2.294-2.295 3.89-2.295s2.992.998 3.89 2.295c.898 1.397 1.396 3.193 1.396 5.088 0 1.896-.498 3.792-1.396 5.089-.898 1.297-2.294 2.294-3.89 2.294s-2.992-.997-3.89-2.294c-.898-1.397-1.396-3.193-1.396-5.089 0-1.895.498-3.791 1.396-5.088ZM17.113 18.18c.399.2.798.698.798 1.297v12.471a.894.894 0 0 1-.898.898.894.894 0 0 1-.897-.898V19.876l-1.796.698c-.498.2-.997-.1-1.197-.499-.2-.499.1-.997.499-1.197l2.095-.798c.498-.2.997-.2 1.396.1Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M41.35 25.064C41.35 35.74 32.673 44.42 22 44.42c-10.672 0-19.35-8.68-19.35-19.356 0-5.587 2.394-10.676 6.284-14.268.4-.299.998-.299 1.297.1.299.4.299.998 0 1.297-3.491 3.193-5.686 7.783-5.686 12.87 0 9.679 7.88 17.561 17.555 17.561s17.555-7.882 17.555-17.56c-.1-9.678-7.98-17.56-17.655-17.56h-.399l3.591 3.592c.4.399.4.898 0 1.297-.399.399-.898.399-1.297 0L18.71 7.204c-.2-.199-.3-.399-.3-.698 0-.3.1-.499.3-.599L23.895.72c.4-.399.898-.399 1.297 0 .4.4.4.898 0 1.297l-3.59 3.592H22c10.673.1 19.35 8.78 19.35 19.456Z"
  })));
});
GoBackward10.displayName = 'GoBackward10';
GoBackward10.defaultProps = {
  'aria-label': 'GoBackward10'
};
export default GoBackward10;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/GoBackward10.js
// module id = 3176
// module chunks = 11